import * as supportActions from '../actions/support';

const initialState = {
    form: {
        initialValues: {
            service_id: null,
            service_email: null,
            sender_email: '',
            sender_full_name: '',
            subject: '',
            body: '',
        },
    },
    showSubmitConfirmation: false,
};

export default (state = initialState, action) => {
    switch(action.type) {

        case supportActions.SUPPORT_FORM_SHOW_SUBMISSION_CONFIRMATION_UPDATED:
            return {
                showSubmitConfirmation: action.show,
            }

        case supportActions.SUPPORT_FORM_INITIAL_VALUES_RESET:
            return {
                ...state,
                form: {
                    initialValues: initialState.form.initialValues,
                }
            }

        case supportActions.SUPPORT_FORM_INITIAL_VALUE_UPDATED:
            return {
                ...state,
                form: {
                    ...state.form,
                    initialValues: {
                        ...state.form.initialValues,
                        [action.key]: action.value,
                    }
                }
            }

        default:
            return state;
    }
}